import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconWarningStyle0 = gravityIconIndividualCss;

const GravityIconWarning = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '587412833cb1cd1fc2026764926a9e566401f79c', color: this.color, size: this.size }, h("svg", { key: '645b3ad1b67f146ed03c9a3b5481833bd4fc7016', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'c64d8e71f1178db94be5ac8f7c8e1126bbe8e0c6', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.57 17.25 11.43 3.11a.49.49 0 0 0-.86 0L2.44 17.25a.5.5 0 0 0 .43.75h16.27a.5.5 0 0 0 .43-.75ZM10.25 9.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-3ZM11 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z", fill: "currentColor" }))));
    }
};
GravityIconWarning.style = GravityIconWarningStyle0;

export { GravityIconWarning as gravity_icon_warning };

//# sourceMappingURL=gravity-icon-warning.entry.js.map